import { render, staticRenderFns } from "./AddFarmModal.vue?vue&type=template&id=398ab4d8"
import script from "./AddFarmModal.vue?vue&type=script&lang=js"
export * from "./AddFarmModal.vue?vue&type=script&lang=js"
import style0 from "./AddFarmModal.vue?vue&type=style&index=0&id=398ab4d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports